import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=23fca8ac&scoped=true"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=23fca8ac&prod&scoped=true&lang=css"
import style1 from "./TopMenu.vue?vue&type=style&index=1&id=23fca8ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fca8ac",
  null
  
)

export default component.exports